import { render, staticRenderFns } from "./RightList.vue?vue&type=template&id=15bd8782&"
import script from "./RightList.vue?vue&type=script&lang=js&"
export * from "./RightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports